// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2EMgt","content":"styles_content__Bmfpn","paragraph":"styles_paragraph__1-_Kb","pic":"styles_pic__1-UOP"};